/**
 * Formats collection response to renderable products Sets
 *
 * @param {prevState} `products array Object`
 * @param {response} `collection response based on GraphQL`
 * @returns Products array Object
 *
 */
export const formatProducts = (prevState, response) => {
  if (response?.data?.collection?.products?.edges) {
    const products = response.data.collection.products.edges.map((product) => {
      return { ...product.node };
    });

    return prevState.concat(products);
  } else {
    console.warn(`Error no products found!`);
    return [];
  }
};
